export default "__VITE_ASSET__B8UWEd_Q__"